const testCsv = `1,2,3,4,5
a,b,c,d,e
f,g,h,i,j`;

export default function downloadReport({ resolve }) {
	setTimeout(() => {
		resolve(testCsv);
	}, 500);
}
